import {
  CreateStripeCheckout,
  CreateStripeCheckoutParams,
  ApiClientError,
} from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useCreateStripeCheckout() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    CreateStripeCheckout,
    ApiClientError,
    CreateStripeCheckoutParams
  >((data) => raydiant.createStripeCheckout(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(keys.stripeCheckout());
    },
  });

  return mutation;
}
